import { render, staticRenderFns } from "./show-company.vue?vue&type=template&id=d0511700&scoped=true"
import script from "./show-company.vue?vue&type=script&lang=js"
export * from "./show-company.vue?vue&type=script&lang=js"
import style0 from "./show-company.vue?vue&type=style&index=0&id=d0511700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0511700",
  null
  
)

export default component.exports